import Stickyfill from 'stickyfilljs';

import {
  BackgroundVideo,
  checkoutMobile,
  Collapse,
  ControlledVideo,
  datepickerField,
  Drawers,
  helpers,
  megaMenuMobile,
  Modal,
  navbar,
  Panel,
  phoneField,
  Range,
  slider,
  Tooltip,
  VideoPlayer,
  videoPlayerPolyv,
} from '@phx-styleguides/als';

import {
  addLoadingState as phxsgAddLoadingState,
  removeLoadingState as phxsgRemoveLoadingState,
} from '@sg/resources/assets/js/helpers/buttons';

import * as Accordion from '@phoenix/components/Accordion';
import { PhxsgToaster } from '@sg/src/View/Components/Atoms/Toaster';

const patchedHelpers = {
  ...helpers,
  buttons: {
    ...helpers.buttons,
    addLoadingState: phxsgAddLoadingState,
    removeLoadingState: phxsgRemoveLoadingState,
  },
};

export {
  BackgroundVideo,
  Accordion,
  PhxsgToaster as PhxToaster,
  checkoutMobile,
  Collapse,
  ControlledVideo,
  datepickerField,
  Drawers,
  patchedHelpers as helpers,
  megaMenuMobile,
  Modal,
  Panel,
  phoneField,
  navbar,
  Range,
  slider,
  Stickyfill,
  Tooltip,
  VideoPlayer,
  videoPlayerPolyv,
};
